import { Box, Stack } from '@mui/material'
import useSettings from "@/hook/useSettings";
import {CARD_STRING_TYPE as CARD_TYPE, MAX_WIDTH} from "@/constant/Constant.ts";
import classes from './card.module.css'
import {useSize} from "ahooks";
import {useMemo} from "react";
interface Props {
  card: any
}

const RCard = (props: Props) => {
  const { card } = props
  const { settings } = useSettings()

  const size = useSize(document.querySelector('body'));
  const cardScale = useMemo(() => {
    let _width = size?.width
    if (_width > MAX_WIDTH) {
      _width = MAX_WIDTH
    }
    const scale = _width / 375
    return scale
  }, [size])

  return (<>
    <Stack className={classes.root}
      sx={(theme) => ({
        width: 172 * cardScale + 'px', //theme.typography.pxToRem(), // '201px',
        maxWidth: 172 * (MAX_WIDTH / 375) + 'px',
      })}
    >
      <Box sx={{
          width: "100%", //theme.typography.pxToRem(), // '201px',
          height:"100%",
      }}>
        <img style={{borderRadius:"14px"}} src={`/images/sonic/sonic-card-vertical.png`} />
      </Box>
      {/* <img src={`/images/card/vertical-${settings.theme}-${card.cardType == CARD_TYPE.VIRTUAL ? 'virtual' : 'physical'}-card.svg#svgView(preserveAspectRatio(none))`} /> */}
      
    </Stack>
  </>)
}

export default RCard;